import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import { LoginFooterComponent } from './login-footer.component';

@NgModule({
  declarations: [LoginFooterComponent],
  imports: [CommonModule, ButtonModule],
  exports: [LoginFooterComponent]
})
export class LoginFooterModule {}
